import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {Link} from 'react-router-dom';
import { getPassCode, getCurrentUser, checkApiError, setCurrentUser } from '../../utils';
import './../../css/manageuserevent.css';
import { useAuth } from "../../Context";
const User = ({showLoading}) => {
    const { setUserData } = useAuth();
  const currentUser = getCurrentUser();
  const navigate = useNavigate();
  const location = useLocation();
  const [organizationLogo, setOrganizationLogo] = useState(null);
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [orgLogoFileName, setOrgLogoFileName] = useState('No file selected');
  const [profilePhotoFileName, setProfilePhotoFileName] = useState('No file selected');
 
  const [inputErrors, setInputErrors] = useState({});
  const [user, setUser] = useState(location.state.attendee || {
    userId: '0',
    userType: 'cab',
    firstName: '',
    lastName: '',
    designation: '',
    emailId: '',
    linkedInProfileURL: '',
    organization: '',
    organizationLogo: '',
    profilePhoto: '',
    profilePhotoPath: '',
    companyLogoPath: ''
  });
  const [userType, setUserType] = useState(user.userType);
  const isAddUser = location.state.mode === 'add' ? true : false;
  
  useEffect(() => {
    if(getPassCode() === ""){
        navigate("/login");
    }
  }, [navigate]);

  const updateProfilePicture = async (_userId) => {
    try {  
        showLoading(true);      
        const response = await fetch(`${process.env.REACT_APP_API_URL}/Attendee/GetUserById?userId=${_userId}`, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${getPassCode()}`
            }
        });
        if(response.status === 200){
            const data = await response.json();
            const updatedUserDetails = { ...currentUser, ...data };  // Assuming the API returns the updated user details
            setUserData(updatedUserDetails);
            setCurrentUser(updatedUserDetails);  // crucial: update utils.currentUser
            //toast.success('Profile picture updated!');
            toast.success('Member details updated.');
            navigate('/user-management');
        }
    } catch (error) {
      // Handle error
    }finally{
        showLoading(false);
    }
  };

  //const user = location.state.user;
  // handle input values to store in user object.
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    //setInputErrors({ ...inputErrors, [name]: null });
    checkFieldValidate(name, value.trim());

    setUser({
      ...user,
        [name]: value
    });
  };

    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    };

    const isValidLinkedinUrl = (url) => {
        return /(https?:\/\/(www.)|(www.))?linkedin.com\/(mwlite\/|m\/)?in\/[a-zA-Z0-9_.-]+\/?/.test(url);
        //return /(^https:\/\/(www\.)?linkedin\.com\/in\/[a-zA-Z0-9-]+$)/.test(url);
    };

    const validateInput = () => {
        const errors = {};
        if (!user.firstName.trim()) {
            errors.firstName = "First name is required.";
        }
        if (!user.lastName.trim()) {
            errors.lastName = "Last name is required.";
        }
        if (!user.designation.trim()) {
            errors.designation = "Designation is required.";
        }
        if (!user.emailId.trim()) {
            errors.emailId = "Official Email is required.";
        } else if (!isValidEmail(user.emailId)) {
            errors.emailId = "Invalid email format.";
        } else if(userType.toLowerCase() === 'cab' && user.emailId.toLowerCase().includes('encora.com')){
            errors.emailId = "CAB member cannot have Encora email.";
        }

        if(user.linkedInProfileURL){
            if (user.linkedInProfileURL.trim() && !isValidLinkedinUrl(user.linkedInProfileURL.trim())) {
                errors.linkedInProfileURL = "Invalid LinkedIn profile URL.";
            }
        }

        if (userType.toLowerCase() === 'cab' && !user.organization.trim()) {
            errors.organization = "Organization is required.";
        }else if(userType.toLowerCase() === 'cab' && user.organization.toLowerCase().includes('encora')){
            errors.organization = "Organization name cannot contain 'ENCORA' for CAB member."
        }

        if (!user.profilePhoto && !user.profilePhotoPath) {
            errors.profilePhoto = "Profile Photo required.";
        }

        if (userType.toLowerCase() === 'cab' && !user.organizationLogo && !user.companyLogoPath) {
            errors.organizationLogo = "Organization Logo required.";
        }
        
        setInputErrors(errors);
        return Object.keys(errors).length === 0; // Return true if no errors
    };

    const checkFieldValidate = (name, value) => {
        let newErrors = { ...inputErrors };
        let flag = false;
        switch (name) {
          case 'firstName':
          case 'lastName':       
          case 'designation':
          case 'organization':
            // Validate: Special characters not allowed except (.,'-&)
            flag = (!/^[a-zA-Z0-9\s-,.'&/]*$/.test(value));      
            break;
          default:
            break;
        }
    
        if (flag) {
          newErrors[name] = "Special characters not allowed except (. , ' - & /)";
        } else {
          delete newErrors[name];
        }
    
        setInputErrors(newErrors);
      }

    // handle file change and show select image in a preview view
    const handleFileChange = (event, setFile) => {
        const name = event.target.name;
        const file = event.target.files[0];
        const errors = { ...inputErrors };
        delete errors[name];

        if (file) {
            const fileSizeInMB = file.size / (1024 * 1024);
            const allowedTypes = ['image/jpeg', 'image/png'];

            if (!allowedTypes.includes(file.type)) {
                errors[name] = 'Only JPG and PNG files are allowed.';
                event.target.value = null;
                if(event.target.id === 'profilePhoto'){
                    setProfilePhotoFileName('No file selected');
                    setProfilePhoto(null); 
                }else{
                    setOrgLogoFileName('No file selected');
                    setOrganizationLogo(null); 
                }  
            } else if (fileSizeInMB > 1) {
                errors[name] = 'File size exceeds the 1MB limit.';
                event.target.value = null;
                if(event.target.id === 'profilePhoto'){
                    setProfilePhotoFileName('No file selected');
                    setProfilePhoto(null);
                }else{
                    setOrgLogoFileName('No file selected');
                    setOrganizationLogo(null);
                }  
            } else { 
                if(event.target.id === 'profilePhoto'){
                    setProfilePhotoFileName(file.name);
                }else{
                    setOrgLogoFileName(file.name);
                } 
                setFile(URL.createObjectURL(file));
            }
        } else {
            if(event.target.id === 'profilePhoto'){
                setProfilePhotoFileName('No file selected');
                setProfilePhoto(null);
            }else{
                setOrgLogoFileName('No file selected');
                setOrganizationLogo(null);
            } 
        }
        setInputErrors(errors);
        user[name] = errors[name] ? null : file;
    };

  // handle user type selection
  const handleUserType = (e) => {
    setUserType(e.target.value.toLowerCase());
    if(e.target.value === 'encora'){
        user.organization = 'Encora';
    }else{
        user.organization = '';
    }
    handleInputChange(e);
  }

  // handle custom file input 
  const handleFileInput = (_id) => {
    const fileInputBtn = document.getElementById(_id);
    fileInputBtn.click();
  };

  const callAddApi = async (formData) => {
    try {
        showLoading(true);
        const response = await fetch(`${process.env.REACT_APP_API_URL}/Attendee/Add`, { 
            method: 'POST',
            headers: {
                "Authorization": `Bearer ${getPassCode()}`,
            },
            body: formData,
        });

        if(checkApiError(response.status)){ navigate("/login"); return; }

        if (response.status === 200) {
            const data = await response.json();
            if(data.statusCode === 200){
                toast.success('Member added.');
                navigate('/user-management');
            }else if(data.statusCode === 400 && data.message === 'This email ID is already in use. Please use a different email.'){
                const errors = {};
                errors.emailId = "This email ID already exits.";
                setInputErrors(errors);
            }else if(data.statusCode === 400 && data.message === "Organization name cannot contain 'ENCORA' for CAB users."){
                const errors = {};
                errors.organization = "Organization name cannot contain 'ENCORA' for CAB member.";
                setInputErrors(errors);
            }
        } else {
            toast.error('Error!');            
        }
    } catch (error) {
        console.error('Error Member details not saved:', error);
    }finally{
        showLoading(false);
    }
  }

  const callUpdateApi = async (formData) => {
    try {
        showLoading(true);
        const response = await fetch(`${process.env.REACT_APP_API_URL}/Attendee/Update`, { 
            method: 'PUT',
            headers: {
                "Authorization": `Bearer ${getPassCode()}`,
              },
            body: formData,
        });

        if(checkApiError(response.status)){ navigate("/login"); return; }

        if (response.status === 200) {
            const data = await response.json();
            if(data.statusCode === 200){
                if(currentUser.userId === formData.get('userId')){
                    updateProfilePicture(formData.get('userId'));
                }else{
                    toast.success('Member details updated.');
                    navigate('/user-management');
                }
            }
        } else if(response.status === 400){
            const data = await response.json();
            if(data.statusCode === 400 && data.message === 'Email ID already exists. Please use a different email.'){
                const errors = {};
                errors.emailId = "This email ID already exits.";
                setInputErrors(errors);
            }
            if(data.statusCode === 400 && data.message === "Organization name cannot contain 'ENCORA' for CAB users."){
                const errors = {};
                errors.organization = "Organization name cannot contain 'ENCORA' for CAB member.";
                setInputErrors(errors);
            }
        } else {
            toast.error('Error!');
        }
    } catch (error) {
        console.error('Error Member details not saved:', error);
    }finally{
        showLoading(false);
    }
  }

  // handle form data submit
  const onClickSumbit = async (e) => {
    e.preventDefault();
    if (validateInput()) {
        const formData = new FormData();
        const frm = document.querySelector('form');
        const pp = frm.profilePhoto ? frm.profilePhoto.files[0] : null;
        const ol = frm.organizationLogo ? frm.organizationLogo.files[0] : null;
        formData.append('userType', frm.userType.value);
        formData.append('firstName', frm.firstName.value);
        formData.append('lastName', frm.lastName.value);
        formData.append('designation', frm.designation.value);
        formData.append('emailId', frm.emailId.value);
        formData.append('linkedInProfileURL', frm.linkedInProfileURL.value);
        formData.append('organization', frm.organization.value);

        if(!user.profilePhoto && user.profilePhotoPath){
            formData.append("profilePhotoPath",  user.profilePhotoPath);
        }else{
            formData.append('profilePhoto', pp);
        }

        if(!user.organizationLogo && user.companyLogoPath){
            formData.append("companyLogoPath",  user.companyLogoPath);
        }else{
            formData.append('organizationLogo', ol);
        }
        
        if(isAddUser){
            formData.append('createdById', currentUser.userId);
            callAddApi(formData).then(() => {
                //navigate('/user-management');
            });
        }else{
            formData.append('lastModifiedById', currentUser.userId);
            formData.append('userId', user.userId);
            callUpdateApi(formData).then(() => {
                //navigate('/user-management');
            });
        }
    }
  }

  return (
    <div className="manage-user-events w3-container mt-4 mb-5">
        <p className="roboto-bold mb-2 color-black t-h">{isAddUser ? 'Add Members' : 'Edit Member' }</p>
        
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb fs-0-8">
                <li className="breadcrumb-item">
                    <Link className='color-purple' to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                    <Link className='color-purple' to="/user-management">Manage Members</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                    {isAddUser ? 'Add Members' : 'Edit Member' }
                </li>
            </ol>
        </nav>
        <div className="card mt-4">
            <div className="card-body p-4">            
                <form encType="multipart/form-data">
                    <div className="row">
                        <div className="col-md-6 mb-4">
                            <label htmlFor="userType" className="form-label">
                            {isAddUser && <span className="text-danger">*</span>} Select User Type:
                            </label>
                            <select id="userType" name="userType" className={`form-select ${inputErrors.userType && 'border-danger'}`} onChange={handleUserType} value={user.userType.toLowerCase()} disabled={!isAddUser}>
                                <option value="cab">CAB Member</option>
                                <option value="encora">Encora Leader</option>
                            </select>
                            {inputErrors.userType && <div className="text-danger small mt-1">{inputErrors.userType}</div>}
                        </div>
                        <div className="col-md-6 mb-4">
                            <label htmlFor="organization" className="form-label">
                            <span className="text-danger">*</span> Organization Name:
                            </label>
                            <input type="text" name="organization" id="organization" value={user.organization} disabled={userType === 'encora'} className={`form-control ${inputErrors.organization && 'border-danger'}`} onChange={handleInputChange} />
                            {inputErrors.organization && <div className="text-danger small mt-1">{inputErrors.organization}</div>}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 mb-4">
                            <label htmlFor="firstName" className="form-label">
                                <span className="text-danger">*</span> First Name:
                            </label>
                            <input type="text" name="firstName" id="firstName" className={`form-control ${inputErrors.firstName && 'border-danger'}`} value={user.firstName} onChange={handleInputChange} />
                            {inputErrors.firstName && <div className="text-danger small mt-1">{inputErrors.firstName}</div>}
                        </div>

                        <div className="col-md-6 mb-4">
                            <label htmlFor="lastName" className="form-label">
                            <span className="text-danger">*</span> Last Name:
                            </label>
                            <input type="text" name="lastName" id="lastName" className={`form-control ${inputErrors.lastName && 'border-danger'}`} value={user.lastName} onChange={handleInputChange} />
                            {inputErrors.lastName && <div className="text-danger small mt-1">{inputErrors.lastName}</div>}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 mb-4">
                            <label htmlFor="designation" className="form-label">
                            <span className="text-danger">*</span> Designation:
                            </label>
                            <input type="text" name="designation" id="designation" className={`form-control ${inputErrors.designation && 'border-danger'}`} value={user.designation} onChange={handleInputChange} />
                            {inputErrors.designation && <div className="text-danger small mt-1">{inputErrors.designation}</div>}
                        </div>                        
                        <div className={`col-md-6 mb-4`}>
                            <label htmlFor="officialEmail" className="form-label">
                            <span className="text-danger">*</span> Official Email Address:
                            </label>
                            <input type="text" id="officialEmail" className={`form-control ${inputErrors.emailId && 'border-danger'}`} name="emailId" value={user.emailId} onChange={handleInputChange} />
                            {inputErrors.emailId && <div className="text-danger small mt-1">{inputErrors.emailId}</div>}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 mb-4">
                            <label htmlFor="linkedinUrl" className="form-label"> LinkedIn Profile URL: </label>
                            <input type="url" name="linkedInProfileURL" id="linkedinUrl" className={`form-control ${inputErrors.linkedInProfileURL && 'border-danger'}`} value={user.linkedInProfileURL} onChange={handleInputChange} />
                            {inputErrors.linkedInProfileURL && <div className="text-danger small mt-1">{inputErrors.linkedInProfileURL}</div>}
                        </div>

                        {userType.toLowerCase() === 'cab' ? 
                            (
                                <div className="col-md-6 mb-4">
                                    <label className="form-label">
                                    <span className="text-danger">*</span> Upload Organization Logo:
                                    </label>
                                    <div className="d-flex justify-content-between align-items-start">
                                        <div className="flex-fill pe-3">
                                            <div className="custom-file-input">
                                                <input name="organizationLogo" id="organizationLogo" type="file" className="form-control me-2" onChange={(e) => handleFileChange(e, setOrganizationLogo)} />
                                                <div className={`form-control custom-input ${inputErrors.organizationLogo && 'border-danger'}`}>
                                                    <span>{orgLogoFileName}</span>
                                                    <button type="button" className="btn btn-purple btn-sm" onClick={()=>{handleFileInput("organizationLogo")}}> Browse </button>
                                                </div>
                                            </div>
                                            <small className="text-muted"> Max File Size: 1 MB, Supported File Formats: jpg, png </small>
                                            {inputErrors.organizationLogo && <div className="text-danger small mt-1">{inputErrors.organizationLogo}</div>}
                                        </div>
                                        <div className="border d-flex align-items-center justify-content-center" style={{ width: "120px", height: "60px" }}>
                                            {organizationLogo || user.companyLogoPath ? (
                                            <img
                                                src={organizationLogo || (process.env.REACT_APP_API_URL+'/'+user.companyLogoPath)}
                                                alt="Organization Logo"
                                                style={{ maxWidth: "100%", maxHeight: "100%" }}
                                            />
                                            ) : (
                                                <small>Preview</small>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="col-md-6 mb-4">
                                    <label className="form-label">
                                    <span className="text-danger">*</span> Upload Profile Photo:
                                    </label>
                                    <div className="d-flex justify-content-between align-items-start">
                                        <div className="flex-fill pe-3">
                                        <div className="custom-file-input">
                                                <input name="profilePhoto" id="profilePhoto" type="file" className="form-control me-2" onChange={(e) => handleFileChange(e, setProfilePhoto)} />
                                                <div className={`form-control custom-input ${inputErrors.profilePhoto && 'border-danger'}`}>
                                                    <span>{profilePhotoFileName}</span>
                                                    <button type="button" className="btn btn-purple btn-sm" onClick={()=>{handleFileInput("profilePhoto")}}> Browse </button>
                                                </div>
                                            </div>
                                            <small className="text-muted"> Max File Size: 1 MB, Supported File Formats: jpg, png </small>
                                            {inputErrors.profilePhoto && <div className="text-danger small mt-1">{inputErrors.profilePhoto}</div>}
                                        </div>
                                        <div
                                            className="border rounded-circle d-flex align-items-center justify-content-center"
                                            style={{ width: "90px", height: "90px" }}
                                        >
                                            {profilePhoto || user.profilePhotoPath ? (
                                                <img
                                                    src={profilePhoto || (process.env.REACT_APP_API_URL+'/'+user.profilePhotoPath)}
                                                    alt=''
                                                    className="rounded-circle"
                                                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                                                />
                                            ) : (
                                            <small>Preview</small>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>

                    <div className="row">
                        {userType.toLowerCase() === 'cab' ? 
                            (
                                <div className="col-md-6 mb-4 mt-n1-5-d">
                                    <label className="form-label">
                                        <span className="text-danger">*</span> Upload Profile Photo:
                                    </label>
                                    <div className="d-flex justify-content-between align-items-start">
                                        <div className="flex-fill pe-3">
                                            <div className="custom-file-input">
                                                <input name="profilePhoto" id="profilePhoto" type="file" className="form-control me-2" onChange={(e) => handleFileChange(e, setProfilePhoto)} />
                                                <div className={`form-control custom-input ${inputErrors.profilePhoto && 'border-danger'}`}>
                                                    <span>{profilePhotoFileName}</span>
                                                    <button type="button" className="btn btn-purple btn-sm" onClick={()=>{handleFileInput("profilePhoto")}}> Browse </button>
                                                </div>
                                            </div>
                                            <small className="text-muted"> Max File Size: 1 MB, Supported File Formats: jpg, png </small>
                                            {inputErrors.profilePhoto && <div className="text-danger small mt-1">{inputErrors.profilePhoto}</div>}
                                        </div>
                                        <div
                                            className="border rounded-circle d-flex align-items-center justify-content-center"
                                            style={{ width: "90px", height: "90px" }}
                                        >
                                            {profilePhoto || user.profilePhotoPath ? (
                                                <img
                                                    src={profilePhoto || (process.env.REACT_APP_API_URL+'/'+user.profilePhotoPath)}
                                                    alt=''
                                                    className="rounded-circle"
                                                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                                                />
                                            ) : (
                                                <small>Preview</small>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="col-md-6 mb-4 mt-n2-5">
                                    <div className="d-flex align-items-center">
                                        <div className="me-3">Organization Logo: </div>
                                        <img src='/encora-logo-black.svg' alt={"Encora Company Logo"} className="user-encora-logo" />
                                    </div>
                                </div>
                            )
                        }
                    </div>

                    <div className="d-flex justify-content-start">
                        <button type="submit" className="btn btn-purple me-2" onClick={onClickSumbit}> Submit </button>
                        <button type="button" className="btn btn-secondary" onClick={()=>{navigate("/user-management")}}>Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
  );
};

export default User;
